import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { TextContainerProps, TextContainerBox, ButtonData } from "./TextContainer.d";

export const TextContainerPart = (props: ComponentProps<PartData>) => {
    const {
        tag,
        title,
        undertitle,
        content,
        isAccordion = false,
        defaultOpen = false,
        columns,
        boxes = [],
        footerTitle,
        footerContent,
        button,
    } = (props.data as TextContainerProps) ?? {};

    const renderButton = (btn: ButtonData) => (
        <div className="text-container__button-wrap">
            <a
                href={btn.url || "#"}
                className={["btn", btn.style, btn.margin].filter(Boolean).join(" ")}
            >
                {btn.label}
            </a>
        </div>
    );

    const gridClass = columns ? `text-container__grid--cols-${columns}` : "text-container__grid--cols-1";
    const filledBoxes = boxes.filter(b => b.boxTitle || b.boxContent);

    const bgClass = (bg?: string) => {
        if (bg === "red") return "text-container__card--red";
        if (bg === "grey") return "text-container__card--grey";
        return "";
    };

    const renderContent = () => content ? (
        <div
            className="text-container__content"
            dangerouslySetInnerHTML={{ __html: content }}
        />
    ) : null;

    const renderBoxes = () => filledBoxes.length > 0 ? (
        <div className={`text-container__grid ${gridClass}`}>
            {filledBoxes.map((box: TextContainerBox, idx: number) => (
                <div
                    key={idx}
                    className={[
                        "text-container__card",
                        bgClass(box.boxBackground),
                    ].filter(Boolean).join(" ")}
                >
                    {box.boxTitle && (
                        <h3 className="text-container__card-title">{box.boxTitle}</h3>
                    )}
                    {box.boxContent && (
                        <div
                            className="text-container__card-content"
                            dangerouslySetInnerHTML={{ __html: box.boxContent }}
                        />
                    )}
                </div>
            ))}
        </div>
    ) : null;

    const renderFooter = () => (footerTitle || footerContent) ? (
        <div className="text-container__footer">
            {footerTitle && (
                <h3 className="text-container__footer-title">{footerTitle}</h3>
            )}
            {footerContent && (
                <div
                    className="text-container__footer-content"
                    dangerouslySetInnerHTML={{ __html: footerContent }}
                />
            )}
        </div>
    ) : null;

    if (isAccordion) {
        return (
            <div className="container">
                <section className="text-container text-container--accordion">
                    <details
                        open={defaultOpen || undefined}
                        className="text-container__details"
                    >
                        <summary className="text-container__summary">
                            <span className="text-container__summary-title">{title}</span>
                            {tag && <span className="text-container__tag">{tag}</span>}
                        </summary>
                        <div className="text-container__accordion-body">
                            {undertitle && (
                                <p className="text-container__undertitle">{undertitle}</p>
                            )}
                            {renderContent()}
                            {renderBoxes()}
                            {renderFooter()}
                            {button && renderButton(button)}
                        </div>
                    </details>
                </section>
            </div>
        );
    }

    return (
        <div className="container">
            <section className="text-container">
                {(tag || title || undertitle) && (
                    <div className="text-container__header">
                        {(tag || title) && (
                            <div className="text-container__title-row">
                                {tag && <span className="text-container__tag">{tag}</span>}
                                {title && <h2 className="text-container__title">{title}</h2>}
                            </div>
                        )}
                        {undertitle && (
                            <p className="text-container__undertitle">{undertitle}</p>
                        )}
                    </div>
                )}
                {renderContent()}
                {renderBoxes()}
                {renderFooter()}
                {button && renderButton(button)}
            </section>
        </div>
    );
};

export default TextContainerPart;
